import { Component, ViewEncapsulation, OnInit, ViewChild } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW1321Model } from './kymw1321.model';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { GetNvalPeriodCSVService} from './api-services/get-nval-period-csv.service';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { PlessDialogServiceSub } from 'src/app/commons/kymw00/pless-dialog-service-sub';
import { GetPlanGoodsMediumtService } from '../kymw1300/api-services/get-plan-goods-medium.service';
import { GetBundleCatalogRoundInfoListService } from '../kymw1300/api-services/get-bundle-catalog-round-info-list.service';
import { BundleCatalogRoundInfoListModel } from '../kymw1300/vo/bundle-catalog-round-info-list.model';
import { OrderCodeTextInputComponent } from 'src/app/commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';

/**
 * プロモ商品企画点検リスト画面を管理するクラス
 *
 * @export KYMW1321Component
 * @class KYMW1321Component
 */
@Component({
  selector: 'app-kymw1321',
  templateUrl: 'kymw1321.component.html',
  styleUrls: ['kymw1321.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW1321Component extends PlessViewHelperSub implements OnInit {
  kymw1321Model: KYMW1321Model = new KYMW1321Model();
  isDisabledBundleCatalog: boolean = true;

  private readonly OUTPUTFLG_NVAL: string = "1";
  private readonly OUTPUTFLG_PREORDER: string = "2";

  /**
   *Creates an instance of KYMW1321Component.
   * @param {KYMW00Model} kymw00Model
   * @param {SaveInspectListService} saveInspectListService
   * @param {FileDownloadConfirmService} fileDownloadConfirmService
   * @memberof KYMW1321Component
   */
  constructor(
    private kymw00Model: KYMW00Model,
    public getNvalPeriodCSVService : GetNvalPeriodCSVService,
    public fileDownloadConfirmService: FileDownloadConfirmService,
    public dialogService: PlessDialogServiceSub,
    public getPlanGoodsMediumtService: GetPlanGoodsMediumtService,
    public getBundleCatalogRoundInfoListService: GetBundleCatalogRoundInfoListService,
  ) {
    super(kymw00Model);
  }

  @ViewChild('txt_StartOrderCode', { static: true }) txt_StartOrderCode: OrderCodeTextInputComponent;
  @ViewChild('txt_EndOrderCode', { static: true }) txt_EndOrderCode: OrderCodeTextInputComponent;

  /**
   * 初期処理
   *
   * @memberof KYMW1321Component
   */
  public ngOnInit() {
    this.componentName = 'KYMW1321';
    this.kymw1321Model.kymw1321Component = this;

    this.getPlanGoodsMediumtService.execute(this.kymw1321Model, (data: any) => {
      // 媒体コンボボックスのフィルタリング（初期値はNVAL）
      this.eventOutputFlag_CHANGEHandler();
    });
  }

  /**
   * 媒体の対象ラジオボタン 変更時
   * 
   * @memberof KYMW1321Component
   */
  public eventOutputFlag_CHANGEHandler() {
    // 媒体リストをフィルタリング
    this.kymw1321Model.dispMediumTypeList = this.kymw1321Model.mediumTypeList.filter((medium, i) => i === 0 || medium.MediumGroupDiv === this.kymw00Model.MEDIUM_GROUP_DIV_NVAL);
    this.kymw1321Model.selectedMediumType = '';
    this.eventMediumType_CHANGEHandler();
  }

  /**
   * 媒体区分変更時
   * 
   * @memberof KYMW1321Component
   */
  public eventMediumType_CHANGEHandler(): void {
    // 媒体選択時に束ね企画回を活性化
    this.isDisabledBundleCatalog = PlessViewUtilsSub.isEmpty(this.kymw1321Model.selectedMediumType);

    this.clearBundle();
    if (!this.isDisabledBundleCatalog) {
      this.getBundleCatalogList();
    }
  }

  /**
   * 束ね企画回情報クリア
   * 
   * @memberof KYMW1321Component
   */
  private clearBundle(): void {
    this.kymw1321Model.selectBundleCatalogRound = '';
    this.kymw1321Model.dispBundleCatalogRoundInfoList = [];
    this.kymw1321Model.startBundleOrderCode = '';
    this.kymw1321Model.endBundleOrderCode = '';
  }

  /**
   * 束ね企画情報取得
   * 
   * @memberof KYMW1321Component
   */
  private getBundleCatalogList(): void {
    const vo = { mediumType: this.kymw1321Model.selectedMediumType };
    this.getBundleCatalogRoundInfoListService.execute(vo, (data: any) => {
      this.kymw1321Model.dispBundleCatalogRoundInfoList = data.BundleCatalogRoundList;
      // 先頭に空を追加
      this.kymw1321Model.dispBundleCatalogRoundInfoList.unshift(new BundleCatalogRoundInfoListModel());
    });
  }

  /**
   * 束ね企画回変更時
   * 
   * @memberof KYMW1321Component
   */
  public eventBundleCatalogGuideStandardName_CHANGEHandler(): void {
    const selectBundle =
      this.kymw1321Model.dispBundleCatalogRoundInfoList.find(item => item.BundleCatalogRoundId === this.kymw1321Model.selectBundleCatalogRound);
    this.kymw1321Model.startBundleOrderCode = selectBundle?.StartOrderCode ?? '';
    this.kymw1321Model.endBundleOrderCode = selectBundle?.EndOrderCode ?? '';
  }

  /**
   * 出力ボタン押下時
   *
   */
  public eventOutput_CLICKHandler(): void {
    if (!this.validation()) return;

    const vo = {
      mediumType: this.kymw1321Model.selectedMediumType,
      bundleCatalogRoundId: this.kymw1321Model.selectBundleCatalogRound,
      orderCode: this.kymw1321Model.startOrderCode,
      pCode: this.kymw1321Model.pCode,
      itemCode: this.kymw1321Model.itemCode,
      orderNum: this.kymw1321Model.orderNum,
      startOrderCode: this.kymw1321Model.startBundleOrderCode,
      endOrderCode: this.kymw1321Model.endBundleOrderCode,
    };

    // API呼び出し
    this.getNvalPeriodCSVService.execute(vo, (data: any) => {
      // ファイル名の設定
      const fileName = '1物N価取扱期間一覧表_' + PlessViewUtilsSub.formatedNowDate('YYYYMMDD') + '.csv';

      this.fileDownloadConfirmService.show(data.FileName, fileName);
    });
  }

  private validation(): boolean {
    // 束ね企画名、受注コードがどちらも未入力の場合
    if (PlessViewUtilsSub.isEmpty(this.kymw1321Model.selectBundleCatalogRound)
      && PlessViewUtilsSub.isEmpty(this.kymw1321Model.selectedMediumType)
      && PlessViewUtilsSub.isEmpty(this.kymw1321Model.startOrderCode)
      && PlessViewUtilsSub.isEmpty(this.kymw1321Model.pCode)
      && PlessViewUtilsSub.isEmpty(this.kymw1321Model.itemCode)
      && PlessViewUtilsSub.isEmpty(this.kymw1321Model.orderNum)
    ) {
      this.dialogService.openAlertGetMessage('E0143');
      return false;
    }

    return true;
  }
}
